import { useEffect, useState } from "react";
import DayTimeslot from "./dayTimeslot"
import TitleDay from "./titleDay"
import { useSelector } from "react-redux";
import { HttpService } from "../../services/HttpService";
import { updateSelectedBookingId, updateSelectedTimeslotId } from "../../redux/reducer/prenotationViewReducer";
import { useAppDispatch } from "../../redux";

const ListDayTimeslot = (props: any) => {
  // internal state
  const [timeslots, setTimeslots] = useState<any[]>([]);
  // redux state
  const {
    selectedDay,
    selectedTimeslotId,
    timeslotListUpdate
  } = useSelector((state: any) => state.prenotationView);
  const { eventId } = useSelector((store: any) => store.login);
  const dispatch = useAppDispatch();

  // Load timeslot list on day change.
  useEffect(() => {
    if (!selectedDay) {
      return;
    }

    HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/day/${selectedDay}/timeslot`
    ).then(response => {
      const incomingTimeslots = response.data;

      // search the selected timeslot
      const selectedTimeslot = incomingTimeslots.find((t: any) => t._id === selectedTimeslotId);
      // if no timeslot specified, select the first one
      if (!selectedTimeslot && incomingTimeslots.length > 0) {
        timeslotSelection(incomingTimeslots[0]._id);
      }

      setTimeslots(incomingTimeslots);

    }).catch(error => {
      console.log(error)
      setTimeslots([])
    });
  }, [selectedDay, timeslotListUpdate]);

  /**
   * Timeslot selection.
   * Selection from parent or click on a timeslot on the left.
   * @param {string} timeslotId - ID of selected timeslot.
   */
  const timeslotSelection = (timeslotId: string) => {
    // update redux state
    dispatch(updateSelectedTimeslotId(timeslotId))
    // reset booking selection, the first one will be opened
    dispatch(updateSelectedBookingId(''))

    if (typeof props.onTimeslotSelection === 'function') {
      props.onTimeslotSelection(timeslotId);
    }
  };

  return (
    <>
      <TitleDay />

      <div className="ListDayTimeslot scrollY">
        {timeslots.map((timeslot: any, index: any) => (
          <div id={"timeslot" + timeslot._id} key={timeslot._id}>
            <DayTimeslot
              handelClick={() => timeslotSelection(timeslot._id)}
              timeslot={timeslot}
              active={(selectedTimeslotId === timeslot._id)}
            />
          </div>
        ))}
      </div>
    </>
  )
}

export default ListDayTimeslot
